import sgccApi from "@/api/sgccApi"

export const obtainAllBudgets = async ( { commit } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/presupuesto`)
        if (data.ok) {
            commit('setBudgets', data.presupuestos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainAllTeachersBudgets = async ( { commit }, codigo ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/presupuesto/docentes/${codigo}`)
        if (data.ok) {
            commit('setTeachers', data.docentes)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainAllProjects = async ( { commit }, { tipo, cedula } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/presupuesto-usuario/proyectos/${tipo}/${cedula}`)
        if (data.ok) {
            commit('setProjects', data.proyectos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editBudget = async ( _, { form } ) => {
    const budgetsForm = {
        nombre: form.nombre,
        fechaInicio: typeof form.fechaInicio == "object" ? form.fechaInicio.getFullYear()+"-"+(form.fechaInicio.getMonth()+1)+"-"+form.fechaInicio.getDate() : form.fechaInicio,
        fechaFin: typeof form.fechaFin == "object" ? form.fechaFin.getFullYear()+"-"+(form.fechaFin.getMonth()+1)+"-"+form.fechaFin.getDate() : form.fechaFin,
        cohorte_id: form.cohorte_id,
        tipoServicio_id: form.tipoServicio_id
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/presupuesto/${form.id}`, budgetsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const createBudget = async ( _, { form } ) => {
    const budgetsForm = {
        nombre: form.nombre,
        fechaInicio: typeof form.fechaInicio == "object" ? form.fechaInicio.getFullYear()+"-"+(form.fechaInicio.getMonth()+1)+"-"+form.fechaInicio.getDate() : form.fechaInicio,
        fechaFin: typeof form.fechaFin == "object" ? form.fechaFin.getFullYear()+"-"+(form.fechaFin.getMonth()+1)+"-"+form.fechaFin.getDate() : form.fechaFin,
        cohorte_id: form.cohorte_id,
        tipoServicio_id: form.tipoServicio_id
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/presupuesto`, budgetsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const createBudgetUserProjects = async ( _, { form } ) => {
    console.log(form);
    
    const budgetsForm = {
        docente_id: form.docente_id,
        derecho_pecunario_id: form.derecho_pecunario_id,
        proyectos: form.proyectos,
        tipoMateria_id: form.tipoMateria_id,
        presupuesto_id: form.presupuesto_id
    }
    console.log(budgetsForm);
    
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/presupuesto-usuario`, budgetsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editBudgetUserProjects = async ( _, { form } ) => {
    const budgetsForm = {
        proyectos: form.proyectos,
        derecho_pecunario_id: form.derecho_pecunario_id,
        tipoMateria_id: form.tipoMateria_id
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/presupuesto-usuario/${form.id_presupuesto_user}`, budgetsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deleteBudget = async ( _, id ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.delete(`/api/presupuesto/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deleteBudgetUser = async ( _, id ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.delete(`/api/presupuesto-usuario/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const checkCoordinate = async (_, { form }) => {
    const budgetsForm = {
        check: form.check,
        comentario: form.comentario,
        currentRole: form.currentRole
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/presupuesto/validar/${form.codigo}`, budgetsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}